import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../Layout';
import { fetchRefersList, clearMessage } from '../../../redux/slices/customer/inviteSlice';
import Pagination from '../../../components/common/Pagination';
import '../../../global.css';
import './styles.css';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import showAlert from '../../../components/common/showAlert';
import api from '../../../api';
import Back from '../../../components/common/Back';

const Payments = () => {
  const dispatch = useDispatch();
  const { totalPages, currentPage, refers_list } = useSelector((state) => state.customer_refers);
  const [activeTab, setActiveTab] = useState('invite');
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    dispatch(clearMessage());
    dispatch(fetchRefersList(1));
  }, []);

  const handlePageChange = (page) => {
    dispatch(fetchRefersList(page));
  };

  const setEmailFunc = (e) => {
    setEmail(e.target.value);
  };

  const handleInvite = async () => {
    if (email == '') {
      showAlert('error', 'Please enter email to invite!'); return false;
    }
    setIsLoading(true);
     try {
        const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/refer-user?email=`+email);
        const data = response.data;
        if (data.success) {
           showAlert('success', 'Invitation sent successfully');
           setEmail('');
        } else {
          showAlert('error', data.message);
        }
        dispatch(clearMessage());
        dispatch(fetchRefersList(1));
        setIsLoading(false);
      } catch (err) {
        alert('Error processing payment.');
        setIsLoading(false);
      }
  };

  return (
    <Layout>
      <main className="main">
        <header className="main-head flex justify-between align-center">
          <h1 className="greet-user-text">Invite User</h1>
          <div className="ms-auto">
            <Back />
          </div>
        </header>

        <div className="main-content">
          <div className="tabs">
            <button
              className={`tab-button ${activeTab === 'invite' ? 'active' : ''}`}
              onClick={() => setActiveTab('invite')}
            >
              Refer User
            </button>
            <button
              className={`tab-button ${activeTab === 'referslist' ? 'active' : ''}`}
              onClick={() => setActiveTab('referslist')}
            >
              Previous Refers List
            </button>
          </div>

          {activeTab === 'referslist' && (
            <div className="tab-content">
              <div className="payments-container mt-4">
                <h2>Transaction Details</h2>
                <div className="card responsive-table-container mt-4 p-0">
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Sent To</th>
                        <th>Status</th>
                        <th>Invitation Sent On</th>
                      </tr>
                    </thead>
                    <tbody>
                      {refers_list.length > 0 ? (
                        refers_list.map((ref) => (
                          <tr key={ref.id}>
                            <td>{ref.sent_to || 'N/A'}</td>
                            <td>
                              <span
                                className={`badge ${
                                  ref.joined_status == 1 ? 'badge-success' : 'badge-warning'
                                }`}
                              >
                                {ref.joined_status == 1 ? 'Completed' : 'Pending'}
                              </span>
                            </td>
                            <td>{ref.created_at_display || 'N/A'}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" style={{ textAlign: 'center' }}>You never invited any users.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
                </div>
              </div>
            </div>
          )}

          {activeTab === 'invite' && (
            <div className="tab-content">
              <div className="account-info mt-4">
                <h4>Enter email of user to send invitation.</h4>
                <div className="card p-4">
                  <input
                    type="text"
                    className="form-control"
                    name="email"
                    value={email}
                    onChange={(e) => setEmailFunc(e)}
                    placeholder="Enter email here..."
                  />
                  <div className="actions mt-4">
                    <button className="btn btn-primary mr-2" onClick={handleInvite}>{isLoading ? 'Sending Invite' : 'Invite'} </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>

    </Layout>
  );
};

export default Payments;
